<div class="component-page-header" [ngClass]="AppConfig.theme"></div>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/page/component-page-header/component-page-header.component.html